module.exports = __webpack_public_path__ + "static/media/iconTotalSharePost.47060548.svg";